import * as LabelPrimitive from '@radix-ui/react-label'

import { cn } from '@/shared/lib/utils'

function Label({ className, ...props }) {
  return (
    <LabelPrimitive.Root
      className={cn(
        'text-xs font-semibold tracking-[0.08em] text-muted-foreground uppercase',
        className,
      )}
      {...props}
    />
  )
}

export { Label }
